import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import MobileTabBar from './MobileTabBar';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="pb-[calc(64px+env(safe-area-inset-bottom,0px))] sm:pb-0">
        <Outlet />
      </main>
      <MobileTabBar />
    </div>
  );
};

export default Layout;
